// ===== Packages =====

import React                                    from 'react';
import styled                                   from 'styled-components';
import { v4 as uuidv4 }                         from 'uuid';

// ===== Constants =====

import {
    DEFAULT_FONT_SIZE,
    BODY_FONT_SIZE,
    READER_VIEW_PARAGRAPH_TEXT_FONT_MULTIPLIER,
    READER_VIEW_PARAGRAPH_TEXT_FONT_MULTIPLIER_SMALL,
}                                               from '../../../constants/generalConstants';
import FONT_TYPE                                from '../../../constants/fontType';

// ===== Styles =====

import { basicEditorFontStyles }                from '../../../styles';

BlockQuote.defaultProps = {
    paragraphId: undefined,
    plainText: undefined,
};
interface Props {
    paragraphId?: string,
    plainText?: string,
    children: React.ReactNode,
    attributes: React.HTMLAttributes<HTMLElement>,
}
function BlockQuote({
    paragraphId,
    plainText,
    children,
    attributes,
}: Props): JSX.Element {
    // Fall back to a runtime id so legacy block quotes still remain clickable
    // as internal-link targets before normalization persists a paragraphId.
    const resolvedParagraphId = paragraphId || uuidv4();
    const normalizedTargetLabel = `${plainText || ''}`.replace(/\s+/g, ' ').trim();

    return (
        <Container
            {...attributes}
            data-paragraph-id={resolvedParagraphId}
            data-post-link-target-id={resolvedParagraphId}
            {...(normalizedTargetLabel
                ? {
                    'data-post-link-target-label': normalizedTargetLabel,
                }
                : {}
            )}
        >
            {children}
        </Container>
    );
}

// ===== Styled Components =====

const Container = styled.blockquote`
    ${basicEditorFontStyles}
    position: relative;
    font-size: 1.5em;
    font-weight: 500;
    color: ${({ theme }) => theme.color.cream300};
    font-style: italic;
    padding: ${`${0.9375 * BODY_FONT_SIZE}px 0px`};
    padding-left: ${`${1.875 * BODY_FONT_SIZE}px`};
    margin: ${`${3 * BODY_FONT_SIZE}px ${1 * BODY_FONT_SIZE}px`};
    margin-bottom: ${`${2.5 * BODY_FONT_SIZE}px`};
    scroll-margin-top: ${`${3.5 * BODY_FONT_SIZE}px`};

    ::before {
        position: absolute;
        top: -15px;
        left: -7px;
        content: "“";
        font-size: 4em;
        font-family: ${FONT_TYPE.IOWAN_OLD_STYLE};
        color: ${({ theme }) => theme.color.cream400};
    }

    ::after {
        position: absolute;
        bottom: -50px;
        right: -15px;
        content: "”";
        font-size: 4em;
        font-family: ${FONT_TYPE.IOWAN_OLD_STYLE};
        color: ${({ theme }) => theme.color.cream400};
    }

    ${({ theme }) => theme.mediaQuery.small} {
        font-size: ${`${READER_VIEW_PARAGRAPH_TEXT_FONT_MULTIPLIER}em`};
        margin-left: 0px;
        margin-right: ${`${1 * DEFAULT_FONT_SIZE}px`};
    }

    ${({ theme }) => theme.mediaQuery.extraSmall} {
        font-size: ${`${READER_VIEW_PARAGRAPH_TEXT_FONT_MULTIPLIER_SMALL}em`};
        margin-left: 0px;
        margin-right: ${`${1 * DEFAULT_FONT_SIZE}px`};
        padding-left: ${`${0.9375 * BODY_FONT_SIZE}px 0px`};
    }
`;

export default BlockQuote;
